import { Icon } from '../../Icon'

export interface InputNumericButtonsProps {
  increment: () => void
  decrement: () => void
  disabled?: boolean
}

export function InputNumericButtons({ increment, decrement, disabled }: InputNumericButtonsProps) {
  return (
    <div className='absolute right-0 top-0 flex h-9 w-[18px] flex-col items-center justify-center'>
      <button
        type='button'
        disabled={disabled}
        className='flex h-[18px] w-full items-center justify-center border-b border-l border-b-[#D1D5DB] border-l-[#D1D5DB] disabled:cursor-not-allowed'
        onClick={increment}
        data-testid='input-numeric-up-btn'
      >
        <Icon name='arrow-short-up' className='text-[#9CA3AF]' />
      </button>
      <button
        disabled={disabled}
        type='button'
        className='flex h-[18px] w-full  items-center justify-center border-l border-l-[#D1D5DB] disabled:cursor-not-allowed'
        onClick={decrement}
        data-testid='input-numeric-down-btn'
      >
        <Icon name='arrow-short-down' className='text-[#9CA3AF]' />
      </button>
    </div>
  )
}
